import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "filter",
  "use": "filter-usage",
  "viewBox": "0 0 21 16",
  "content": "<symbol viewBox=\"0 0 21 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"filter\"><path d=\"M0 4H11.5M21 4H17.5\" stroke-width=\"1.5\" /><path d=\"M21 12H9.5M0 12H3.5\" stroke-width=\"1.5\" /><circle cx=\"14.5\" cy=\"4\" r=\"3\" stroke-width=\"1.5\" /><circle cx=\"3\" cy=\"3\" r=\"3\" transform=\"matrix(-1 0 0 1 9.5 9)\" stroke-width=\"1.5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol